import { FetcherWithComponents, NavigateOptions, To, useActionData, useNavigate } from "react-router-dom";


interface RedirectOptions {
  to: To;
  options?: NavigateOptions;
}

export interface IRedirectActionData {
  redirect?: RedirectOptions;
}

export function useRedirectFromActionData(fetcher?: FetcherWithComponents<any>) {
  const actionData = useActionData() as IRedirectActionData | undefined;
  // fetcher.data can be kept between page loads, use it only when data is reloaded after a form submission
  const isFetcherReloadingAfterAction = (fetcher?.state === "loading") && (fetcher?.formData !== undefined);
  const fetcherData = isFetcherReloadingAfterAction ? fetcher?.data as IRedirectActionData | undefined : undefined;
  const navigate = useNavigate();

  if (actionData?.redirect) {
    navigate(actionData.redirect.to, actionData.redirect.options);
  } else if (fetcherData?.redirect) {
    navigate(fetcherData.redirect.to, fetcherData.redirect.options);
    // have to clear this info to avoid possible endless redirection cycles
    fetcherData.redirect = undefined;
  }
}

export function addRedirectActionData<T>(actionData: T, redirect: RedirectOptions): T & IRedirectActionData {
  return { ...actionData, redirect };
}
